"use strict";

exports.__esModule = true;
exports.generateID = void 0;
var s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
var generateID = () => s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
exports.generateID = generateID;
//# sourceMappingURL=generateId.js.map